// import React from "react";
// import {
//   Code,
//   Database,
//   CloudUpload,
//   AlertTriangle,
//   TrendingUp,
//   Lock,
//   Users,
//   MessageCircle,
//   HelpCircle,
//   Smartphone,
//   Settings,
// } from "tabler-icons-react";

// export default function Software() {
//   return (
//     <div>
//       <div className="text-center mb-12">
//         <h3 className="text-2xl font-bold text-gray-900 mb-4">
//           Milk Collection & Dairy Management Software
//         </h3>
//         <p className="text-lg text-gray-600">
//           Comprehensive software solution for modern dairy collection centers
//         </p>
//       </div>

//       <div className="grid md:grid-cols-2 gap-8 mb-12">
//         <div className="bg-gradient-to-br from-emerald-50 to-emerald-100 p-8 rounded-2xl hover:shadow-lg transition-shadow">
//           <div className="bg-emerald-500 p-4 rounded-full w-16 h-16 mb-6 flex items-center justify-center">
//             <Code className="w-8 h-8 text-white" />
//           </div>
//           <h4 className="text-xl font-bold text-gray-900 mb-4">
//             Core Features
//           </h4>
//           <ul className="list-disc list-inside text-gray-700 space-y-2">
//             <li>RFID/Biometric farmer registration & milk tracking</li>
//             <li>Fat, SNF, and temperature-based quality testing</li>
//             <li>Cloud storage & synchronization across branches</li>
//             <li>SMS/Email alerts for collection & quality issues</li>
//             <li>Seasonal & supplier-specific rate management</li>
//           </ul>
//         </div>

//         <div className="bg-gradient-to-br from-indigo-50 to-indigo-100 p-8 rounded-2xl hover:shadow-lg transition-shadow">
//           <div className="bg-indigo-500 p-4 rounded-full w-16 h-16 mb-6 flex items-center justify-center">
//             <CloudUpload className="w-8 h-8 text-white" />
//           </div>
//           <h4 className="text-xl font-bold text-gray-900 mb-4">
//             Integration & Access
//           </h4>
//           <ul className="list-disc list-inside text-gray-700 space-y-2">
//             <li>IoT-based milk tester and weighing scale integration</li>
//             <li>ERP, booking system, and PMS API support</li>
//             <li>Mobile/web apps for field staff and farmers</li>
//             <li>Fully responsive dashboards</li>
//             <li>Secure, real-time updates across devices</li>
//           </ul>
//         </div>
//       </div>

//       <div className="grid md:grid-cols-3 gap-8 mb-12">
//         <div className="text-center">
//           <div className="bg-red-100 p-6 rounded-full w-20 h-20 mx-auto mb-4 flex items-center justify-center">
//             <AlertTriangle className="w-10 h-10 text-red-600" />
//           </div>
//           <h5 className="text-lg font-semibold text-gray-900 mb-2">
//             Alerts & Notifications
//           </h5>
//           <p className="text-gray-600">
//             SMS/Email alerts for issues & rejections
//           </p>
//         </div>

//         <div className="text-center">
//           <div className="bg-yellow-100 p-6 rounded-full w-20 h-20 mx-auto mb-4 flex items-center justify-center">
//             <TrendingUp className="w-10 h-10 text-yellow-600" />
//           </div>
//           <h5 className="text-lg font-semibold text-gray-900 mb-2">
//             Reports & Analytics
//           </h5>
//           <p className="text-gray-600">
//             PDF/Excel reports, trend charts, CRM insights
//           </p>
//         </div>

//         <div className="text-center">
//           <div className="bg-blue-100 p-6 rounded-full w-20 h-20 mx-auto mb-4 flex items-center justify-center">
//             <Lock className="w-10 h-10 text-blue-600" />
//           </div>
//           <h5 className="text-lg font-semibold text-gray-900 mb-2">
//             Role-Based Access
//           </h5>
//           <p className="text-gray-600">
//             2FA, encryption, and multi-tiered access
//           </p>
//         </div>
//       </div>

//       <div className="grid md:grid-cols-3 gap-8">
//         <div className="text-center">
//           <div className="bg-pink-100 p-6 rounded-full w-20 h-20 mx-auto mb-4 flex items-center justify-center">
//             <Users className="w-10 h-10 text-pink-600" />
//           </div>
//           <h5 className="text-lg font-semibold text-gray-900 mb-2">
//             CRM Features
//           </h5>
//           <p className="text-gray-600">
//             Loyalty programs, feedback collection, and guest profiling
//           </p>
//         </div>

//         <div className="text-center">
//           <div className="bg-green-100 p-6 rounded-full w-20 h-20 mx-auto mb-4 flex items-center justify-center">
//             <MessageCircle className="w-10 h-10 text-green-600" />
//           </div>
//           <h5 className="text-lg font-semibold text-gray-900 mb-2">
//             Multilingual Support
//           </h5>
//           <p className="text-gray-600">
//             Nepali, English, Hindi UI & training tools
//           </p>
//         </div>

//         <div className="text-center">
//           <div className="bg-gray-100 p-6 rounded-full w-20 h-20 mx-auto mb-4 flex items-center justify-center">
//             <HelpCircle className="w-10 h-10 text-gray-600" />
//           </div>
//           <h5 className="text-lg font-semibold text-gray-900 mb-2">
//             24/7 Support
//           </h5>
//           <p className="text-gray-600">
//             Dedicated support team for cooperatives
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }

///new

// import React from "react";
// import {
//   Code,
//   CloudUpload,
//   AlertTriangle,
//   TrendingUp,
//   Lock,
//   Users,
//   MessageCircle,
//   Headset,
// } from "tabler-icons-react";

// export default function Software() {
//   return (
//     <div>
//       <div className="text-center mb-12">
//         <h3 className="text-2xl font-bold text-gray-900 mb-4">
//           Milk Collection & Dairy Management Software
//         </h3>
//         <p className="text-lg text-gray-600">
//           Comprehensive software solution for modern dairy collection centers
//         </p>
//       </div>

//       <div className="grid md:grid-cols-2 gap-8 mb-12">
//         <div className="bg-gradient-to-br from-emerald-50 to-emerald-100 p-8 rounded-2xl hover:shadow-lg transition-shadow">
//           <div className="bg-emerald-500 p-4 rounded-full w-16 h-16 mb-6 flex items-center justify-center">
//             <Code className="w-8 h-8 text-white" />
//           </div>
//           <h4 className="text-xl font-bold text-gray-900 mb-4">
//             Core Features
//           </h4>
//           <ul className="list-disc list-inside text-gray-700 space-y-2">
//             <li>RFID/Biometric farmer registration & milk tracking</li>
//             <li>Fat, SNF, and temperature-based quality testing</li>
//             <li>Cloud storage & synchronization across branches</li>
//             <li>SMS/Email alerts for collection & quality issues</li>
//             <li>Seasonal & supplier-specific rate management</li>
//           </ul>
//         </div>

//         <div className="bg-gradient-to-br from-indigo-50 to-indigo-100 p-8 rounded-2xl hover:shadow-lg transition-shadow">
//           <div className="bg-indigo-500 p-4 rounded-full w-16 h-16 mb-6 flex items-center justify-center">
//             <CloudUpload className="w-8 h-8 text-white" />
//           </div>
//           <h4 className="text-xl font-bold text-gray-900 mb-4">
//             Integration & Access
//           </h4>
//           <ul className="list-disc list-inside text-gray-700 space-y-2">
//             <li>IoT-based milk tester and weighing scale integration</li>
//             <li>ERP, booking system, and PMS API support</li>
//             <li>Mobile/web apps for field staff and farmers</li>
//             <li>Fully responsive dashboards</li>
//             <li>Secure, real-time updates across devices</li>
//           </ul>
//         </div>
//       </div>

//       <div className="grid md:grid-cols-3 gap-8 mb-12">
//         <div className="text-center">
//           <div className="bg-red-100 p-6 rounded-full w-20 h-20 mx-auto mb-4 flex items-center justify-center">
//             <AlertTriangle className="w-10 h-10 text-red-600" />
//           </div>
//           <h5 className="text-lg font-semibold text-gray-900 mb-2">
//             Alerts & Notifications
//           </h5>
//           <p className="text-gray-600">
//             SMS/Email alerts for issues & rejections
//           </p>
//         </div>

//         <div className="text-center">
//           <div className="bg-yellow-100 p-6 rounded-full w-20 h-20 mx-auto mb-4 flex items-center justify-center">
//             <TrendingUp className="w-10 h-10 text-yellow-600" />
//           </div>
//           <h5 className="text-lg font-semibold text-gray-900 mb-2">
//             Reports & Analytics
//           </h5>
//           <p className="text-gray-600">
//             PDF/Excel reports, trend charts, CRM insights
//           </p>
//         </div>

//         <div className="text-center">
//           <div className="bg-blue-100 p-6 rounded-full w-20 h-20 mx-auto mb-4 flex items-center justify-center">
//             <Lock className="w-10 h-10 text-blue-600" />
//           </div>
//           <h5 className="text-lg font-semibold text-gray-900 mb-2">
//             Role-Based Access
//           </h5>
//           <p className="text-gray-600">
//             2FA, encryption, and multi-tiered access
//           </p>
//         </div>
//       </div>

//       <div className="grid md:grid-cols-3 gap-8">
//         <div className="text-center">
//           <div className="bg-pink-100 p-6 rounded-full w-20 h-20 mx-auto mb-4 flex items-center justify-center">
//             <Users className="w-10 h-10 text-pink-600" />
//           </div>
//           <h5 className="text-lg font-semibold text-gray-900 mb-2">
//             CRM Features
//           </h5>
//           <p className="text-gray-600">
//             Loyalty programs, feedback collection, and guest profiling
//           </p>
//         </div>

//         <div className="text-center">
//           <div className="bg-green-100 p-6 rounded-full w-20 h-20 mx-auto mb-4 flex items-center justify-center">
//             <MessageCircle className="w-10 h-10 text-green-600" />
//           </div>
//           <h5 className="text-lg font-semibold text-gray-900 mb-2">
//             Multilingual Support
//           </h5>
//           <p className="text-gray-600">
//             Nepali, English, Hindi UI & training tools
//           </p>
//         </div>

//         <div className="text-center">
//           <div className="bg-gray-100 p-6 rounded-full w-20 h-20 mx-auto mb-4 flex items-center justify-center">
//             <Headset className="w-10 h-10 text-gray-600" />
//           </div>
//           <h5 className="text-lg font-semibold text-gray-900 mb-2">
//             24/7 Support
//           </h5>
//           <p className="text-gray-600">
//             Dedicated support team for cooperatives
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }

//
import React from "react";
import {
  Code,
  CloudUpload,
  AlertTriangle,
  TrendingUp,
  Lock,
  Users,
  MessageCircle,
  Headset,
} from "tabler-icons-react";
import softwareImage from "../image/softwareimg.jpg";

export default function Software() {
  return (
    <div>
      <div className="text-center mb-12">
        <h3 className="text-2xl font-bold text-gray-900 mb-4">
          Milk Collection & Dairy Management Software
        </h3>
        <p className="text-lg text-gray-600">
          Comprehensive software solution for modern dairy collection centers
        </p>
      </div>

      <div className="flex justify-center mb-12">
        <img
          src={softwareImage}
          alt="Software Overview"
          className="rounded-xl shadow-lg max-w-full h-auto"
        />
      </div>

      <div className="grid md:grid-cols-2 gap-8 mb-12">
        <div className="bg-gradient-to-br from-emerald-50 to-emerald-100 p-8 rounded-2xl hover:shadow-lg transition-shadow">
          <div className="bg-emerald-500 p-4 rounded-full w-16 h-16 mb-6 flex items-center justify-center">
            <Code className="w-8 h-8 text-white" />
          </div>
          <h4 className="text-xl font-bold text-gray-900 mb-4">
            Core Features
          </h4>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>RFID/Biometric farmer registration & milk tracking</li>
            <li>Fat, SNF, and temperature-based quality testing</li>
            <li>Cloud storage & synchronization across branches</li>
            <li>SMS/Email alerts for collection & quality issues</li>
            <li>Seasonal & supplier-specific rate management</li>
          </ul>
        </div>

        <div className="bg-gradient-to-br from-indigo-50 to-indigo-100 p-8 rounded-2xl hover:shadow-lg transition-shadow">
          <div className="bg-indigo-500 p-4 rounded-full w-16 h-16 mb-6 flex items-center justify-center">
            <CloudUpload className="w-8 h-8 text-white" />
          </div>
          <h4 className="text-xl font-bold text-gray-900 mb-4">
            Integration & Access
          </h4>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>IoT-based milk tester and weighing scale integration</li>
            <li>ERP, booking system, and PMS API support</li>
            <li>Mobile/web apps for field staff and farmers</li>
            <li>Fully responsive dashboards</li>
            <li>Secure, real-time updates across devices</li>
          </ul>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-8 mb-12">
        <div className="text-center">
          <div className="bg-red-100 p-6 rounded-full w-20 h-20 mx-auto mb-4 flex items-center justify-center">
            <AlertTriangle className="w-10 h-10 text-red-600" />
          </div>
          <h5 className="text-lg font-semibold text-gray-900 mb-2">
            Alerts & Notifications
          </h5>
          <p className="text-gray-600">
            SMS/Email alerts for issues & rejections
          </p>
        </div>

        <div className="text-center">
          <div className="bg-yellow-100 p-6 rounded-full w-20 h-20 mx-auto mb-4 flex items-center justify-center">
            <TrendingUp className="w-10 h-10 text-yellow-600" />
          </div>
          <h5 className="text-lg font-semibold text-gray-900 mb-2">
            Reports & Analytics
          </h5>
          <p className="text-gray-600">
            PDF/Excel reports, trend charts, CRM insights
          </p>
        </div>

        <div className="text-center">
          <div className="bg-blue-100 p-6 rounded-full w-20 h-20 mx-auto mb-4 flex items-center justify-center">
            <Lock className="w-10 h-10 text-blue-600" />
          </div>
          <h5 className="text-lg font-semibold text-gray-900 mb-2">
            Role-Based Access
          </h5>
          <p className="text-gray-600">
            2FA, encryption, and multi-tiered access
          </p>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-8">
        <div className="text-center">
          <div className="bg-pink-100 p-6 rounded-full w-20 h-20 mx-auto mb-4 flex items-center justify-center">
            <Users className="w-10 h-10 text-pink-600" />
          </div>
          <h5 className="text-lg font-semibold text-gray-900 mb-2">
            CRM Features
          </h5>
          <p className="text-gray-600">
            Loyalty programs, feedback collection, and guest profiling
          </p>
        </div>

        <div className="text-center">
          <div className="bg-green-100 p-6 rounded-full w-20 h-20 mx-auto mb-4 flex items-center justify-center">
            <MessageCircle className="w-10 h-10 text-green-600" />
          </div>
          <h5 className="text-lg font-semibold text-gray-900 mb-2">
            Multilingual Support
          </h5>
          <p className="text-gray-600">
            Nepali, English, Hindi UI & training tools
          </p>
        </div>

        <div className="text-center">
          <div className="bg-gray-100 p-6 rounded-full w-20 h-20 mx-auto mb-4 flex items-center justify-center">
            <Headset className="w-10 h-10 text-gray-600" />
          </div>
          <h5 className="text-lg font-semibold text-gray-900 mb-2">
            24/7 Support
          </h5>
          <p className="text-gray-600">
            Dedicated support team for cooperatives
          </p>
        </div>
      </div>
    </div>
  );
}
